import { useContext, useState, useEffect } from "react";
// import { useParams } from "react-router";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { Link } from "react-router-dom";
import useMediaQuery from "@shared/hooks/useMediaQuery";
import { Context } from "../context/DataContext";
import RenderRoutesBalance from "@shared/components/RenderRoutesBalance";
import RenderBankAccounts from "@shared/components/RenderBankAccounts";
import { UseCustomerBalanceV2 } from "@shared/server/fetcher";
import useBankAccounts from "@shared/hooks/useBankAccounts";
import Loading from "@shared/components/Loading";
import { MAX_PENDING_MONTHS_ALLOWED } from "@shared/constants";

const RouteWarning = () => {
  const { state } = useContext(Context);
  const { route } = state;
  // const { route: creditor_id } = useParams();
  const [currentRoute, setCurrentRoute] = useState({});
  const fullScreen = useMediaQuery("min-width:820px");

  // Asks for mainOnly=1 so an owner whose billing is hidden from cobro still sees this
  // page in the central app.
  const { data } = UseCustomerBalanceV2(route.user_id, 1);
  // Without this the payment block below renders its "no pudimos cargar" fallback, on a
  // page whose whole purpose is telling the owner where to pay.
  const { data: bankInformation } = useBankAccounts(route.user_id);

  useEffect(() => {
    // /customer/balance has never returned a `routes` array; this page predates that
    // payload. It used to be masked because the endpoint replied `false` for mainOnly=0,
    // which left the page stuck on <Loading /> and this effect a no-op.
    if (data?.routes) {
      const result = data.routes.filter((x) => x.creditor_id === route.creditor_id)[0];
      setCurrentRoute(result);
    }
    //eslint-disable-next-line
  }, [data]);

  // `false` is a real answer (the owner has no billing row), not a pending request. The
  // shared hook's isLoading is `!data`, which would spin on it forever.
  if (data === undefined) return <Loading />;

  return (
    <div className="container mt-3 mb-5">
      <Typography variant="h4" align="center">
        Aviso!
      </Typography>

      {currentRoute?.route_name && (
        <div>
          <Typography variant="h6" noWrap>
            {currentRoute.route_name} ({currentRoute.location})
          </Typography>

          <div className="mt-2 mb-3">
            <Divider />
            <Divider />
          </div>
        </div>
      )}

      <Typography variant="body1" paragraph>
        <b>Esta ruta tiene pagos vencido, asegurese de no llegar a deber más de {MAX_PENDING_MONTHS_ALLOWED} meses.</b>
      </Typography>

      <RenderRoutesBalance userRoutesBalance={data} />

      <RenderBankAccounts bank={bankInformation} />

      <Box component="div" p={2}>
        <Link to={"/dashboard"}>
          <Button fullWidth={!fullScreen} variant="outlined" color="primary">
            Continuar
          </Button>
        </Link>
      </Box>
    </div>
  );
};

export default RouteWarning;
